import type { IcIcon } from "./types";

export const IcClose: IcIcon = (properties) => (
  <svg
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...properties}
  >
    <path
      d="M1 1l16 16m0-16L1 17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
  </svg>
);
